import api from './api';

export const reviewService = {
  getSellerReviews: (username, page = 0) =>
    api.get(`/reviews/seller/${username}?page=${page}&size=10`),
  getMine: () => api.get('/reviews/mine'),
  getReceived: () => api.get('/reviews/received'),
  create: (data) => api.post('/reviews', data),
  respond: (id, response) => api.patch(`/reviews/${id}/response`, { response }),
  getReviewStatus: (productId) => api.get(`/reviews/status/${productId}`),
};
